/**
 * @file   src\components\MemberWantAd\EditEmailidModal.js
 * @brief  This file is responsible for editing user email.
 * @date   June, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Row, Col, Button } from "react-bootstrap";
import TextBox from "../Common/TextBox";
import { emailValidation } from "../../helpers/validations";
import { changeEmailAddress } from "../../services/v2/userprofileService";
import { toast } from "react-toastify";
import CheckEmailDeletionModal from "../Onboarding/UserRegister/CheckEmailDeletionModal";
import useIsMobile from "@/hooks/useIsMobile";

const EditEmailidModal = (props) => {
  const [email, setEmail] = useState(props.Email);
  const [emailError, setEmailError] = useState("");
  const [buttonDisable, setButtonDisable] = useState(true);
  const [checkEmailPopup, setCheckEmailPopup] = useState(false);
  const isMobile = useIsMobile();
  useEffect(() => {
    setEmail(props.Email);
  }, [props.Email]);

  /**
   * To handle email changes
   * @param {*} e
   */
  const handleEmailChange = (e) => {
    setEmailError("");
    setEmail(e.target.value);
    validate(e.target.value);
  };
  /**
   * To handle validation
   * @param {*} mail
   * @returns
   */
  const validate = (mail) => {
    setButtonDisable(true);
    let isValid = true;
    setEmailError("");
    if (mail.trim() === "") {
      isValid = false;
      setEmailError("Enter Email");
    } else if (!emailValidation(mail.trim())) {
      isValid = false;
      setEmailError("Enter Valid email");
    } else if (isValid) {
      setButtonDisable(false);
    }
    return isValid;
  };
  const handleCancel = () => {
    setEmail(props.Email);
    setEmailError("");
    props.onHide();
  };

  /**
   * To handle email change submit
   */
  const handleSubmit = async () => {
    const data = {
      newEmail: email,
    };
    await changeEmailAddress(data)
      .then((response) => {
        if (response.errorCode === 0) {
          setCheckEmailPopup(true);
          props.onHide();
        } else {
          console.log("response.message", response.message);
          toast.error(response.message);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong");
      });
  };

  const closeCheckEmailDeletionModal = () => {
    setCheckEmailPopup(false);
  };

  return (
    <>
      {checkEmailPopup ? (
        <CheckEmailDeletionModal
          process="email_change"
          email={email}
          oldEmail={props.Email}
          onHide={closeCheckEmailDeletionModal}
        />
      ) : (
        ""
      )}
      <Modal
        show
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-settings"
        fullscreen={isMobile}
      >
        <Modal.Body className="pt-32 pb-32" style={isMobile ? { justifyContent: 'center', display: 'flex', flexDirection: 'column' } : {}}>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={props.onHide}
          ></button>
          <h3 className="text-start">Email address</h3>
          <p className="f-size-16 mb-4">
            You can sign into Gitcha using this email address.
          </p>
          <Row>
            <Col xl={12}>
              <div className="textbox-wrap mb-3 mb-sm-3">
                <label className="form-label">Email</label>
                <TextBox
                  id="mailId"
                  name="emailId"
                  value={email}
                  type="text"
                  placeholder="Email"
                  className="form-control"
                  onChange={(e) => handleEmailChange(e)}
                  errorClass="error-validation-msg"
                  errorMessage={emailError}
                />
              </div>
            </Col>
          </Row>

          <div className="modal-btn-wrap">
            <Button className="btn btn-tertiary me-3" onClick={handleCancel}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleSubmit}
              disabled={buttonDisable}
            >
              Save Changes
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default EditEmailidModal;
